'use client';

import { c as _c } from "react/compiler-runtime";
import { InfoCardMain } from '@sola/ark-skippy/organisms-cms/info-card/main/infoCard-main.tsx';
import type { ComponentBaseProps, FlexibleContentProps } from '@sola/schema/lib/schema.ts';
import { DepartureSpotlightCard } from '../../molecules/departure-spotlight-card/departure-spotlight-card.tsx';
import { useDepartureOverview } from './departure-overview.logic.ts';
type DepartureOverviewContentSlots = {
  infoCardContent?: FlexibleContentProps;
};
export type DepartureOverviewProps = ComponentBaseProps<DepartureOverviewContentSlots>;
export const DepartureOverview: React.FC<DepartureOverviewProps> = t0 => {
  const $ = _c(6);
  const {
    contentSlots
  } = t0;
  const content = useDepartureOverview(contentSlots?.infoCardContent);
  const hasInfoCardContent = Boolean(content?.title || content?.subtitle || content?.body || content?.media || content?.primaryCTA || content?.secondaryCTA || content?.tertiaryCTA || content?.items?.length);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DepartureSpotlightCard />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== content || $[2] !== hasInfoCardContent) {
    t2 = hasInfoCardContent && <InfoCardMain {...content} alt={false} />;
    $[1] = content;
    $[2] = hasInfoCardContent;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="DepartureOverview flex w-full flex-col gap-comfy-xl">{t1}{t2}</div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};